import React from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useGetAllBureausQuery } from "../../app/services/bureauApi";
import { useNavigate } from "react-router-dom";

function ListBureaux() {
  const { data: bureaux, isLoading, isError, error } = useGetAllBureausQuery();
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="xl"
      sx={{
        backgroundColor: "#ffff8d",
        pt: 3,
        pb: 4,
        marginTop: 4,
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        Liste des bureaux de change
      </Typography>

      {/* Loader */}
      {isLoading && <CircularProgress />}

      {/* Erreur */}
      {isError && (
        <Alert severity="error">
          Erreur lors du chargement :{" "}
          {error?.data?.message || "Erreur inconnue"}
        </Alert>
      )}

      {/* Liste des bureaux */}
      {!isLoading && !isError && bureaux?.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#fdd835" }}>
                <TableCell>Nom</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Téléphone</TableCell>
                <TableCell>Adresse</TableCell>
                <TableCell>Quartier</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bureaux.map((bureau) => (
                <TableRow key={bureau.id}>
                  <TableCell>{bureau.nom}</TableCell>
                  <TableCell>{bureau.email}</TableCell>
                  <TableCell>{bureau.telephone}</TableCell>
                  <TableCell>{bureau.adresse}</TableCell>
                  <TableCell>{bureau.quartier}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() =>
                        navigate(`/admin/bureaux/edit/${bureau.id}`)
                      }
                    >
                      Modifier
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Aucun bureau trouvé */}
      {!isLoading && !isError && bureaux?.length === 0 && (
        <Typography>Aucun bureau trouvé.</Typography>
      )}
    </Container>
  );
}

export default ListBureaux;
